export const getArrIdx = (arrLen: number): number =>
  Math.floor(Math.random() * arrLen)

export const isArrLastIdx = (
  arr: Array<unknown>,
  currentIdx: number
): boolean => arr.length - 1 === currentIdx
